<template>
  <div :class="['nav-bar', showRole ? 'big-nav' : 'small-nav']">
    <div :class="['left', showRole ? 'half-left' : 'main-left']">
      <van-icon
        v-if="showBack"
        class="icon"
        name="arrow-left"
        @click="goBack"
      />
      <!-- <div v-if="$slots['left-title']" class="left-title">
        <slot name="left-title"></slot>
      </div> -->
      <div
        :class="['center-title', showRole ? 't-left' : ' t-center']"
        v-html="title"
      ></div>
    </div>
    <div v-if="showRole && !vuexInitData.is_skip_check_role" class="right">
      <van-dropdown-menu>
        <van-dropdown-item
          ref="roleItem"
          :title="currentRoleName"
          :disabled="isAutoLogin"
        >
          <template v-for="item in calRoleList">
            <div
              @click="changeRole(item.value)"
              :class="[
                'role',
                defaultRoleInfo.id === item.value ? 'active' : '',
              ]"
              :key="item.value"
              v-if="item.value !== 'add'"
            >
              {{ item.text }}
            </div>
            <div
              @click="changeRole(item.value)"
              class="add"
              :key="item.value"
              v-else
            >
              <van-icon name="add-o" /><span>
                {{
                  userInfo && userInfo.id
                    ? $t("changeRole.添加角色")
                    : $t("changeRole.点击登录")
                }}
              </span>
            </div>
          </template>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
  </div>
</template>

<script>
import { changeRole } from "@/views/mixins";
import { mapGetters } from "vuex";

export default {
  mixins: [changeRole],
  props: {
    showBack: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    goBack: {
      type: Function,
      default: () => {
        console.log("back");
      },
    },
    showRole: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["userInfo", "vuexInitData"]),
  },
  data() {
    return {
      isAutoLogin: !!sessionStorage.getItem("isAutoLogin"),
    };
  },
  mounted() {},
  methods: {
    changeRole(val) {
      this.handleChangeRole(val, () => {
        this.$emit("change");
        console.log("changeRole");
        this.$refs.roleItem.toggle(false);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.nav-bar {
  position: relative;
  width: 100%;
  z-index: 999;
  top: 0;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #333;
  box-sizing: border-box;
  // &.big-nav {
  //   height: 90px;
  // }
  &.small-nav {
    height: 40px;
  }
  .center-title {
    width: 100%;
    line-height: 41px;
    font-size: 17px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.t-left {
      padding-left: 20px;
    }
  }
  .left-title {
    font-size: 14px;
  }
  .left {
    height: 40px;
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    &.main-left {
      width: 100%;
    }
    &.half-left {
      width: 50%;
    }
    .icon {
      position: absolute;
      left: 0;
      top: 0;
      width: 30px;
      height: 100%;
      font-size: 16px;
      line-height: 40px;
    }
  }
  .right {
    position: absolute;
    right: 0;
    height: 40px;
    z-index: 10;
    width: 50%;
    color: #333;
    overflow: hidden;
    /deep/ .van-dropdown-menu {
      width: 100%;
      background: transparent;
      .van-dropdown-menu__bar {
        height: 40px;
      }
      .van-overlay {
        z-index: 110;
        // overflow: visible;
        &::before {
          position: absolute;
          z-index: 2020;
          content: "";
          top: -1px;
          right: 40px;
          display: block;
          border: 3px solid;
          border-color: transparent transparent #fff transparent;
        }
      }
      .van-dropdown-menu__bar {
        box-shadow: none;
      }
      .van-dropdown-menu__title {
        width: 100%;
        color: @gold;
        font-size: 15px;
        .van-ellipsis {
          // padding-right: 2px;
          text-align: right;
        }
        &::after {
          top: 42%;
          border-width: 5px;
          border-color: transparent transparent @gold @gold;
        }
      }
      .van-popup--top {
        top: 5px;
        right: 0 !important;
        left: calc(100% - 230px);
        width: 214px;
        border-radius: 10px;
      }
    }
  }
}
.role {
  font-size: 13px;
  height: 18px;
  line-height: 18px;
  color: #333;
  padding: 8px 15px;
  border-bottom: 1px solid #f1f1f1;
  &.active {
    color: @gold;
  }
}
.add {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: @gold;
  border-radius: 0 0 10px 10px;
  span {
    margin-left: 5px;
  }
}
</style>
